module.exports = __webpack_public_path__ + "static/media/lizard-brain.bf37ccde.svg";